var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'fortune-wheel': !_vm.newDesign,
    'fortune-wheel-new-design': _vm.newDesign,
    'fortune-wheel_loaded': !_vm.newDesign && _vm.isLoaded,
    'fortune-wheel-new-design_loaded': _vm.newDesign && _vm.isLoaded,
  }},[_c('iframe',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],ref:"iframe",attrs:{"data-src":"https://ebaconline.com.br/new/fortune-wheel/popup","frameborder":"0","width":"100%"},on:{"load":_vm.iframeOnLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }